import React, { Suspense } from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Projects from './components/Projects/Projects';
import Skills from './components/Skills/Skills';
import Experience from './components/Experience/Experience';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import PortfolioStats from './components/PortfolioStats/PortfolioStats';
import styles from './styles/App.module.css';

const ColorPicker = React.lazy(() => import('./components/ColorPicker/ColorPicker'));
const ScrollTools = React.lazy(() => import('./components/ScrollTools/ScrollTools'));
const PortfolioChatbot = React.lazy(() => import('./components/PortfolioChatbot/PortfolioChatbot'));

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <ErrorBoundary>
        <div className={styles.App}>
        <Header />
        <main>
          <Hero />
          <PortfolioStats />
          <Projects />
          <Skills />
          <Experience />
          <Contact />
        </main>
        <Footer />
        <Suspense fallback={null}>
          <ColorPicker />
          <ScrollTools />
          <PortfolioChatbot />
        </Suspense>
        </div>
        </ErrorBoundary>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;